import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Head from 'next/head';

import CompanyFAQMenu from './CompanyFAQMenu';
import CompanyFAQItem from './CompanyFAQItem';

const CompanyFAQ = (props) => {
  const { headlines, faqData, className } = props;
  if (!faqData || !faqData.questions || faqData.questions.length === 0) {
    return null;
  }
  const { questions } = faqData;

  const formatContentAsHTML = (contentArray) => {
    return contentArray
      .map((item) => {
        if (item.type === "paragraph" || item.type === "quote") {
          return `<p>${item.content}</p>`;
        } else if (item.type === "list") {
          return `<ul>${item.content.map((li) => `<li>${li}</li>`).join("")}</ul>`;
        }
        return "";
      })
      .join("");
  };

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": questions.map(faq => ({
      "@type": "Question",
      "name": faq.title,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": formatContentAsHTML(faq.content)
      }
    }))
  };

  return (
    <section className={className}>
      <Head>
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      </Head>
      <Container>
        <Row>
          <Col lg="4" className="pe-0 ps-0 sticky-lg-top" style={{
            top: 120,
            height: "fit-content"
          }}>
           <CompanyFAQMenu title={headlines.faqTitle} items={questions} />
          </Col>
          <Col lg="8">
            {questions.map((question) => (
              <CompanyFAQItem
                title={question.title}
                content={question.content}
                id={question.id}
                key={question.id}
              />
            ))}
          </Col>
        </Row>
      </Container>
    </section>
  )
};

export default CompanyFAQ;
